import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoggedIn: localStorage.getItem("isLoggedIn")
    ? JSON.parse(localStorage.getItem("isLoggedIn"))
    : false,
  userInfo: null,
  token: null,
  isModalVisible: false,
  expireTime: null,
  showLoginModal: false,
  showIdleModal: false,
  modalType: null,
  lastRoute: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setToken: (state, action) => {
      state.token = action.payload;
      // localStorage.setItem("jwt", JSON.stringify(action.payload));
    },
    setUserInfo: (state, action) => {
      state.userInfo = action.payload;
      state.isLoggedIn = true;
      localStorage.setItem("isLoggedIn", true);
      // localStorage.setItem("userInfo", JSON.stringify(action.payload));
    },
    showModal: (state) => {
      state.isModalVisible = true;
    },
    hideModal: (state) => {
      state.isModalVisible = false;
    },
    logout: (state) => {
      state.token = null;
      state.refresh = null;
      state.user = null;
      state.expireTime = null;

      state.showLoginModal = false;
      state.showIdleModal = false;
      state.lastRoute = null;
    },

    // clearUserInfo: (state) => {
    //   state.user = null;
    // },

    // ------------------------
    // Login Modal
    // ------------------------

    showLoginModal: (state) => {
      state.showLoginModal = true;
    },

    hideLoginModal: (state) => {
      state.showLoginModal = false;
    },

    // ------------------------
    // Idle / Session Modal
    // ------------------------

    showIdleModal: (state, action) => {
      state.showIdleModal = true;
      state.modalType = action.payload;
    },

    hideIdleModal: (state) => {
      state.showIdleModal = false;
    },

    // ------------------------
    // Session Expiry
    // ------------------------

    setExpireTime: (state, action) => {
      state.expireTime = action.payload;
    },

    clearExpireTime: (state) => {
      state.expireTime = null;
    },

    // ------------------------
    // Resume Route
    // ------------------------

    saveLastRoute: (state, action) => {
      state.lastRoute = action.payload;
    },
    clearUserInfo: (state) => {
      state.userInfo = null;
      state.token = null;
      state.isLoggedIn = false;
      state.expireTime = null;
      state.showLoginModal = false;
      state.showIdleModal = false;
      state.lastRoute = null;
      const otp = localStorage.getItem('appvalue');
      localStorage.removeItem("isLoggedIn");
      localStorage.removeItem("userInfo");
      localStorage.removeItem("jwt");
      localStorage.removeItem("companyData");
      localStorage.removeItem("industryData");
      localStorage.removeItem("userSelectedCompany");
      localStorage.removeItem("authorizedSignatory");
      localStorage.removeItem("companyAddress");
      localStorage.removeItem("userindividualID");
      localStorage.removeItem("invite_code");
      localStorage.clear();
      if (otp) {
        localStorage.setItem('appvalue', otp);
      }
    },
  },
});

export const { setUserInfo, clearUserInfo, setToken, showModal, hideModal, logout, // Login Modal
  showLoginModal,
  hideLoginModal,

  // Idle Modal
  showIdleModal,
  hideIdleModal,

  // Session
  setExpireTime,
  clearExpireTime,

  // Navigation
  saveLastRoute, } = authSlice.actions;

export default authSlice.reducer;
